import CoconeuseBioTemplate from "../../components/coconeuses/CoconeuseBioTemplate";

const CoconeuseMaiteValouse = () => (
  <CoconeuseBioTemplate
    name="Maïté"
    subtitle="Sagesse incarnée · Mémoire du corps · Libération profonde"
    mainPhoto="https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/64bo4q6r_DSC00675.jpg"
    bioText={[
      "Avec plus de trente années d'expérience au service de l'être, Maïté incarne une présence à la fois douce, ancrée et profondément humaine.",
      "Son accompagnement ouvre des espaces de libération et de transformation là où le corps, les émotions et la mémoire se rencontrent.",
      "Une présence qui se reconnaît plus qu'elle ne s'explique.",
    ]}
    galleryPhotos={[
      "https://customer-assets.emergentagent.com/job_98f24ef8-b599-4c48-83d5-8100dc89f188/artifacts/6c85vnbv_DSC00675%20%281%29.jpg",
      "https://customer-assets.emergentagent.com/job_5c218319-678c-4c56-b4c3-2039fdc76918/artifacts/6w1qtuvh_DSC02243.jpg",
      "https://customer-assets.emergentagent.com/job_5c218319-678c-4c56-b4c3-2039fdc76918/artifacts/qkedidcg_DSC02699.jpg",
    ]}
    expertise={["Libération émotionnelle", "Mémoire du corps", "Sagesse incarnée"]}
    backPath="/coconeuses#profil-maite"
    backLabel="Retour aux Coconeuses"
  />
);

export default CoconeuseMaiteValouse;
